import {
  Code2, Gauge, Cog, Package, BookOpen, Network, FileCode, Users, Radar,
  UserCog, Crosshair, Puzzle, Star, SearchCheck, Megaphone, Rocket,
  ShieldCheck, Trophy, BadgeCheck, Terminal, MessageCircle, Gamepad2, Globe, Youtube,
  Twitch, Twitter, Instagram, Map, Play, Scan, Video,
} from "lucide-react";

export const ICONS = {
  Code2, Gauge, Cog, Package, BookOpen, Network, FileCode, Users, Radar,
  UserCog, Crosshair, Puzzle, Star, SearchCheck, Megaphone, Rocket,
  ShieldCheck, Trophy, BadgeCheck, Terminal, MessageCircle, Gamepad2, Globe, Youtube,
  Twitch, Twitter, Instagram, Map, Play, Scan, Video,
};

export const STATUS = {
  todo: { label: "TODO", color: "#71717A" },
  "in-progress": { label: "IN PROGRESS", color: "#2E6BFF" },
  done: { label: "DONE", color: "#00E676" },
};

export function getIcon(name) {
  return ICONS[name] || Terminal;
}
